
import createIconComponent from '../utils/createIconComponent';
import { SVG_CHEVRON_LEFT_OUTLINED } from '../../../dist';
import React from 'react';
const ChevronLeftOutlinedIcon = createIconComponent({ content: SVG_CHEVRON_LEFT_OUTLINED, height: 24, width: 24 });
ChevronLeftOutlinedIcon.displayName = 'ChevronLeftOutlinedIcon';
export default ChevronLeftOutlinedIcon;
